// NOTE: Palette is available here: https://www.figma.com/design/1ij6KlCz6pD1MXEODq8Vmr/ADS-v2---Design-system?node-id=4492-147709&t=ZYiJtur2lwRVGhCP-0
export const ColorShades = {
  // Green
  Green100: '#07453A',
  Green90: '#095346',
  Green80: '#0A6052',
  Green70: '#0C6E5D',
  Green60: '#43998A',
  Green50: '#5EA89B',
  Green40: '#79B6AC',
  Green30: '#93C5BC',
  Green20: '#AED3CD',
  Green10: '#C9E2DE',

  // Blue
  Blue100: '#3B438E',
  Blue90: '#4751AA',
  Blue80: '#525EC6',
  Blue70: '#5E6CE3',
  Blue60: '#7B88FF',
  Blue50: '#8B97FF',
  Blue40: '#9CA6FF',
  Blue30: '#ACB5FF',
  Blue20: '#BDC3FF',
  Blue10: '#CDD2FF',

  // Orange
  Orange100: '#844700',
  Orange90: '#9F5500',
  Orange80: '#B96300',
  Orange70: '#D47100',
  Orange60: '#F08D1C',
  Orange50: '#F29B39',
  Orange40: '#F4AA55',
  Orange30: '#F6B871',
  Orange20: '#F7C68E',
  Orange10: '#F9D4AA',

  // Yellow
  Yellow100: '#B38C18',
  Yellow90: '#C49A1A',
  Yellow80: '#D6A81C',
  Yellow70: '#E8B61F',
  Yellow60: '#FBD152',
  Yellow50: '#FCD86B',
  Yellow40: '#FCDE84',
  Yellow30: '#FDE59C',
  Yellow20: '#FDEBB5',
  Yellow10: '#FEF2CE',

  Red100: '#832222',
  Red90: '#9D2929',
  Red80: '#B72F2F',
  Red70: '#D13636',
  Red60: '#ED5353',
  Red50: '#EF6868',
  Red40: '#F27E7E',
  Red30: '#F49393',
  Red20: '#F6A9A9',
  Red10: '#F8BEBE',

  // Pink
  Pink100: '#8A3156',
  Pink90: '#A63B67',
  Pink80: '#C24578',
  Pink70: '#DD4F89',
  Pink60: '#FA6BA5',
  Pink50: '#FA7EB0',
  Pink40: '#FB90BC',
  Pink30: '#FCA3C7',
  Pink20: '#FDC8DD',
  Pink10: '#FEDAE9',

  // Aqua
  Aqua100: '#007676',
  Aqua90: '#008D8D',
  Aqua80: '#00A5A5',
  Aqua70: '#00BCBC',
  Aqua60: '#39DEDE',
  Aqua50: '#55E2E2',
  Aqua40: '#71E7E7',
  Aqua30: '#8EECEC',
  Aqua20: '#AAF1F1',
  Aqua10: '#C6F5F5',

  // Purple
  Purple100: '#532C78',
  Purple90: '#633590',
  Purple80: '#743EA8',
  Purple70: '#8447C0',
  Purple60: '#A163DC',
  Purple50: '#AD77E1',
  Purple40: '#B88AE5',
  Purple30: '#C49EE9',
  Purple20: '#D0B1EE',
  Purple10: '#DCC5F2',

  // Grass
  Grass100: '#217338',
  Grass90: '#278A43',
  Grass80: '#2EA14E',
  Grass70: '#34B859',
  Grass60: '#67DA86',
  Grass50: '#7CDF98',
  Grass40: '#92E4A9',
  Grass30: '#A8EABA',
  Grass20: '#BEEFCB',
  Grass10: '#D3F4DD',

  // Plum
  Plum100: '#602073',
  Plum90: '#73278A',
  Plum80: '#862DA1',
  Plum70: '#9934B8',
  Plum60: '#B550D4',
  Plum50: '#BE66DA',
  Plum40: '#C87CDF',
  Plum30: '#D192E4',
  Plum20: '#DAA7EA',
  Plum10: '#E3BDEF',
} as const;
